import { TechnicalSkillsList } from "./components/technicalSkillsList";
import { FormComponent } from "./components/formModelOne";
import React, { Component } from "react";
// import DataFilter from "react-data-filter";
import {
  Button,
  Form,
  Modal,
  Divider,
  Table,
  Input,
  Tag,
  List,
  Card,
  Typography,
  Avatar,
  Icon,
  Progress
} from "antd";
import { connect } from "react-redux";
import uuid from "uuid/v4";
import * as loginActions from "./actions";
import "./projects.css";
import { Link } from "react-router-dom";
import "./view.css";
const { Paragraph } = Typography;
const { Search } = Input;
const { Meta } = Card;
// const data = [
//   {
//     key: "1",
//     name: "John Brown",
//     age: 32,
//     address: "New York No. 1 Lake Park"
//   },
//   {
//     key: "2",
//     name: "Joe Black",
//     age: 42,
//     address: "London No. 1 Lake Park"
//   },
//   {
//     key: "3",
//     name: "Jim Green",
//     age: 32,
//     address: "Sidney No. 1 Lake Park"
//   },
//   {
//     key: "4",
//     name: "Jim Red",
//     age: 32,
//     address: "London No. 2 Lake Park"
//   }
// ];
class Projects extends Component {
  constructor(props) {
    super(props);
    //
    //
    this.state = {
      visible: false,
      loading: false,
      showOther: false,
      filterDropdownVisible: false,
      data: [],
      searchvalue: ""
    };
  }

  onInputChange = e => {
    this.setState({ searchText: e.target.value });
    this.onSearch();
  };
  onSearch = name => () => {
    const { searchText } = this.state;
    const reg = new RegExp(searchText, "gi");
    this.setState({
      filterDropdownVisible: false,
      data: this.props.projects.data
        .map(record => {
          const match = record[name].match(reg);
          if (!match) {
            return null;
          }
          return {
            ...record,
            [name]: (
              <span>
                {record[name]
                  .split(reg)
                  .map((text, i) =>
                    i > 0
                      ? [<span className="highlight">{match[0]}</span>, text]
                      : text
                  )}
              </span>
            )
          };
        })
        .filter(record => !!record)
    });
  };

  showModal = () => {
    this.props.modelFromStep(true, false, 3);
  };

  handleCancel = () => {
    this.props.modelFromStep(false, false, 3);
  };

  editSkillHandler = index => e => {
    this.props.modelFromStep(true, false, 3, index);
  };
  deleteProjectHandler = index => {
    this.props.deleteItem(
      this.props.profile.projectsDoneList[index],
      "projectsDoneList",
      "projectID"
    );
  };

  // componentDidMount() {
  //   //
  //   if (this.props.projects && this.props.projects.valid !== true) {
  //     this.props.loadProjectsList();
  //   }
  // }

  //WARNING! To be deprecated in React v17. Use componentDidMount instead.
  componentWillMount() {
    this.props.loadProjectsList();
  }
  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    //
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      }
    };

    let { projectsDoneList } = this.props.profile;
    const { showOther } = this.state;
    if (typeof projectsDoneList == "undefined") {
      projectsDoneList = [];
    }

    const { form } = this.props;
    const { getFieldDecorator, validateFields } = form;
    const isEdit = this.props.itemIndex !== null;
    const onValidateForm = itemData => e => {
      e.preventDefault();
      validateFields((err, values) => {
        if (!err) {
          if (itemData) {
            values.projectID = itemData.projectID;
          } else {
            values.projectID = uuid();
          }
          //
          //
          this.props.stepFourSubmit(
            values,
            "projectsDoneList",
            "projectID",
            this.props.itemIndex
          );
        }
      });
    };

    const columns = [
      {
        title: "Owner",
        dataIndex: "projectOwner",
        key: "projectOwner",
        render: projectOwner => (
          <Link to={`/home/profile/${projectOwner.uid}`}>
            {projectOwner.name}
          </Link>
        )
      },
      {
        title: "Project Name",
        dataIndex: "projectName",
        key: "projectName",
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              placeholder="Search name"
              value={this.state.searchText}
              onChange={this.onInputChange}
              onPressEnter={this.onSearch("projectName")}
            />
            <Button type="primary" onClick={this.onSearch("projectName")}>
              Search
            </Button>
          </div>
        ),
        filterDropdownVisible: this.state.filterDropdownVisible,
        onFilterDropdownVisibleChange: visible =>
          this.setState({ filterDropdownVisible: visible })
      },

      {
        title: "Description",
        dataIndex: "projectDescription",
        key: "projectDescription"
      },
      {
        title: "Completion Level",
        dataIndex: "projectCompletionLevel",
        key: "projectCompletionLevel"
      },
      {
        title: "Require Assistance?",
        dataIndex: "projectImprovingAssistance",
        key: "projectImprovingAssistance"
      },
      {
        title: "Team or Alone",
        dataIndex: "projectTeam",
        key: "projectTeam"
      },
      {
        title: "Tech used",
        dataIndex: "projectTechnologiesUsed",
        key: "projectTechnologiesUsed",
        render: projectTechnologiesUsed => (
          <span>
            {projectTechnologiesUsed.map(tag => {
              return <Tag key={tag}>{tag.toUpperCase()}</Tag>;
            })}
          </span>
        )
      }
    ];

    //

    return (
      <div className="container" >
        {/* {this.props.projects &&
        this.props.projects.valid &&
        this.props.profile &&
        this.props.profile.role == "STUDENT" ? (
          <>
            <Modal
              visible={this.props.visible.visible}
              title={`${isEdit ? "Update Project" : "Add new project"}`}
              onCancel={this.handleCancel}
              destroyOnClose
              footer={[
                <Button
                  key="submit"
                  type="primary"
                  loading={this.props.visible.loading}
                  onClick={onValidateForm(
                    this.props.itemIndex !== null
                      ? projectsDoneList[this.props.itemIndex]
                      : null
                  )}
                >
                  {`${isEdit ? "Update Project" : "Add Project"}`}
                </Button>
              ]}
            >
              <FormComponent
                technicalSkills={projectsDoneList}
                formItemLayout={formItemLayout}
                getFieldDecorator={getFieldDecorator}
                showOther={showOther}
                onSearch={this.onSearch}
                itemData={
                  this.props.itemIndex !== null
                    ? projectsDoneList[this.props.itemIndex]
                    : null
                }
              />
            </Modal>
            <h2 className="steponeHeading">Projects List</h2>
            <p className="steponeDisc">
              List all your projects,{" "}
              <b style={{ fontWeight: 500 }}>
                You may also add Work in Progress Projects also
              </b>
            </p>
            <TechnicalSkillsList
              data={projectsDoneList}
              showModal={this.showModal}
              editSkill={this.editSkillHandler}
              deleteItem={this.deleteProjectHandler}
              isAuth={true}
            />
            <Divider style={{ backgroundColor: "black" }} />
          </>
        ) : null} */}
        <h2
          className="steponeHeading"
          style={{ marginBottom: 30 }}
        >
          Society Level - Projects List 
        </h2>

        {/*
        <Table
          columns={columns}
          dataSource={this.props.projects.data ? this.props.projects.data : []}
        /> */}
        <Search
          placeholder="Search in table"
          enterButton="Search"
          size="large"
          allowClear
          style={{ marginBottom: 30 }}
          onSearch={value => this.setState({ searchvalue: value })}
        />
        <List
          loading={
            this.props.projects && this.props.projects.valid
              ? !this.props.projects.valid
              : true
          }
          grid={{    gutter: 16,
            xs: 1,
          sm: 1,
          md: 1,
          lg: 3,
          xl: 3,
          xxl: 3, }}
          pagination={{
            pageSize: 30,
            total: this.props.projects.data && this.props.projects.data.length,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
          }}
          dataSource={
            this.props.projects.data
              ? this.props.projects.data.filter(data =>
                  Object.keys(data).filter(
                    key =>
                      data[key] &&
                      data[key]
                        .toString()
                        .toUpperCase()
                        .includes(this.state.searchvalue.toUpperCase())
                  ).length > 0
                    ? true
                    : false
                )
              : []
          }
          renderItem={item => (
            <>
              {}
              {Object.keys(item.projectsDoneList).map((el, index) => (
                <List.Item>
                  <Card bodyStyle={{ height: "380px", overflowY: "auto" }}>
                    <Meta
                      avatar={
                        <Avatar src="https://banner2.kisspng.com/20180331/cgq/kisspng-computer-icons-project-management-icon-design-prog-automation-5ac01c9db76b54.6923660315225396777513.jpg" />
                      }
                      title={item.projectsDoneList[el].projectName}
                    />
                    <div
                      style={{
                        marginTop: 13
                      }}
                    >
                      Completion level :{" "}
                      <Progress
                        percent={
                          item.projectsDoneList[el].projectCompletionLevel
                        }
                      />
                    </div>
                    <div
                      style={{
                        marginTop: 2
                      }}
                    >
                      Description :{" "}
                      <Paragraph
                        ellipsis={{
                          rows: 2,
                          expandable: true,
                          onExpand: a => {}
                        }}
                      >
                        {item.projectsDoneList[el].projectDescription}{" "}
                      </Paragraph>
                    </div>
                    <div
                      style={{
                        marginTop: 2
                      }}
                    >
                      <Icon type="team" />
                      Team : {item.projectsDoneList[el].projectTeam}{" "}
                    </div>
                    <div
                      style={{
                        marginTop: 2
                      }}
                    >
                      <Icon type="user" />
                      Owner :{" "}
                      <Link to={`/home/profile/${item.UID}`}>
                        {item.displayName}
                      </Link>
                    </div>
                    <div
                      style={{
                        marginTop: 2
                      }}
                    >
                      <Icon type="user" />
                      Branch :{item.branch}
                    </div>
                    <div
                      style={{
                        marginTop: 2
                      }}
                    >
                      <Icon type="user" />
                      Campus :{item.campus}
                    </div>
                    <div
                      style={{
                        marginTop: 2
                      }}
                    >
                      <Icon type="user" />
                      gradYear :{item.gradYear}
                    </div>
                    <div
                      style={{
                        marginTop: 10
                      }}
                    >
                      {item.projectsDoneList[el].projectTechnologiesUsed.map(
                        i => (
                          <Tag key={i} style={{ marginBottom: 5 }}>
                            {i.toUpperCase()}
                          </Tag>
                        )
                      )}{" "}
                    </div>
                  </Card>
                </List.Item>
              ))}
            </>
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  //
  //
  return {
    auth: state.firebase.auth,
    step: state.auth.step,
    visible: state.auth,
    profile: state.firebase.profile,
    itemIndex: state.auth.itemIndex,
    projects: state.auth.projects
  };
};

const mapDispachToProps = (dispatch, props) => ({
  stepFourSubmit: (formValue, categary, arrayField, itemIndex = null) => {
    dispatch(
      loginActions.stepWithSkillsSubmit(
        formValue,
        props.history,
        categary,
        3,
        arrayField,
        itemIndex
      )
    );
  },
  modelFromStep: (visible, loading, step, itemIndex = null) => {
    dispatch(loginActions.modelFromStep(visible, loading, step, itemIndex));
  },
  deleteItem: (val, category, arrayField) => {
    dispatch(loginActions.deleteItem(val, category, arrayField));
  },
  loadProjectsList: () => {
    dispatch(loginActions.loadProjectsList());
  },
  onUnload: () => dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Form.create()(Projects));
